import calendarTypes from "../types/calendarTypes";

export const CalendarStyleIdentifiers = {
  absolute: "absolute",
  relativeWeek: "relativeWeek",
  relativeDay: "relativeDay",
  relativeTime: "relativeTime"
};

export const CalendarStyleNames = {
  absolute: "Absolute (Regular dates)",
  relativeWeek: "Weekly (Week 1, Week 2)",
  relativeDay: "Daily (Day 1, Day 2)",
  relativeTime: "Time (+2:25:33)"
};

const CalendarStyleValues = {
  absolute: calendarTypes.CALENDAR_TYPE_DATE_TIME,
  relativeWeek: calendarTypes.CALENDAR_TYPE_WEEKDAY_TIME,
  relativeDay: calendarTypes.CALENDAR_TYPE_DAY_TIME,
  relativeTime: calendarTypes.CALENDAR_TYPE_HOUR_TIME
};

const createCalendarStyle = id => {
  return {
    identifier: id,
    name: CalendarStyleNames[id],
    value: CalendarStyleValues[id]
  };
};

export default [
  createCalendarStyle(CalendarStyleIdentifiers.absolute),
  createCalendarStyle(CalendarStyleIdentifiers.relativeWeek),
  createCalendarStyle(CalendarStyleIdentifiers.relativeDay),
  createCalendarStyle(CalendarStyleIdentifiers.relativeTime)
];
